import { Layout } from "components/Layout/Layout";
import { ManagePersonalDetailsRoutes } from "./ManagePersonalDetailsRoutes";

export const ManagePersonalDetails = () => (
  <Layout>
    <Layout.Header>Manage personal details</Layout.Header>
    <Layout.Main>
      <ManagePersonalDetailsRoutes />
    </Layout.Main>
  </Layout>
);
